/* Touché · Búsqueda tolerante a errores de tipeo
   - Página de búsqueda: si hay 0 a 2 resultados, corrige las palabras mal
     escritas con el vocabulario de la tienda (/search?view=vocab) y muestra
     los resultados de la búsqueda corregida, con un aviso para volver.
   - Buscador rápido: con pocos resultados sugiere "¿Quisiste decir …?".
   - Traduce las opciones de "Ordenar por".
   Los sinónimos se editan en SINONIMOS (claves sin tildes ni ñ). */
(function () {
  'use strict';

  var SINONIMOS = {
    anteojo: 'lentes', anteojos: 'lentes', gafa: 'lentes', gafas: 'lentes',
    monedero: 'billetera', monederos: 'billeteras', morral: 'mochila', morrales: 'mochilas',
    maleta: 'valija', maletas: 'valijas', zapatos: 'calzado', zapas: 'zapatillas',
    cinto: 'cinturon', carterita: 'cartera', carteritas: 'carteras'
  };

  var ORDEN = {
    'manual': 'Destacados',
    'best-selling': 'Más vendidos',
    'relevance': 'Más relevantes',
    'title-ascending': 'Nombre: A - Z',
    'title-descending': 'Nombre: Z - A',
    'price-ascending': 'Menor precio',
    'price-descending': 'Mayor precio',
    'created-ascending': 'Más antiguos',
    'created-descending': 'Más nuevos'
  };

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  var vocabPromise = null;
  function armar(lista) {
    var mapa = {}, palabras = [];
    String(lista || '').split(',').forEach(function (w) {
      w = w.trim();
      if (w.length < 3) return;
      var n = norm(w);
      if (!n || n.indexOf(' ') !== -1 || mapa[n]) return;
      mapa[n] = w;
      palabras.push(n);
    });
    return { mapa: mapa, palabras: palabras };
  }
  function pedirPagina(n) {
    return fetch('/search?view=vocab&page=' + n, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        try { var j = JSON.parse(t.trim()); return { w: String(j.w || ''), p: parseInt(j.p, 10) || 1 }; }
        catch (e) { return { w: '', p: 1 }; }
      })
      .catch(function () { return { w: '', p: 1 }; });
  }
  function cargarVocabulario() {
    if (vocabPromise) return vocabPromise;
    vocabPromise = new Promise(function (resolve) {
      var cache = null;
      try { cache = sessionStorage.getItem('touche_vocab_v2'); } catch (e) {}
      if (cache) { resolve(armar(cache)); return; }
      pedirPagina(1).then(function (primera) {
        var resto = [];
        for (var n = 2; n <= Math.min(primera.p, 8); n++) resto.push(pedirPagina(n));
        return Promise.all(resto).then(function (otras) {
          var lista = [primera.w].concat(otras.map(function (o) { return o.w; })).join(',');
          if (lista.replace(/,/g, '')) { try { sessionStorage.setItem('touche_vocab_v2', lista); } catch (e) {} }
          resolve(armar(lista));
        });
      }).catch(function () { resolve(armar('')); });
    });
    return vocabPromise;
  }

  /* Distancia entre palabras (letras cambiadas, de más, de menos o invertidas) */
  function distancia(a, b, max) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return max + 1;
    var prev2 = null, prev = [], cur, i, j, v, costo, minFila;
    for (j = 0; j <= lb; j++) prev[j] = j;
    for (i = 1; i <= la; i++) {
      cur = [i];
      minFila = i;
      for (j = 1; j <= lb; j++) {
        costo = a[i - 1] === b[j - 1] ? 0 : 1;
        v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + costo);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, prev2[j - 2] + 1);
        cur[j] = v;
        if (v < minFila) minFila = v;
      }
      if (minFila > max) return max + 1;
      prev2 = prev;
      prev = cur;
    }
    return prev[lb];
  }

  function corregir(texto, voc) {
    var palabras = norm(texto).split(' ').filter(Boolean);
    if (!palabras.length) return null;
    var cambio = false;
    var salida = palabras.map(function (w) {
      if (SINONIMOS[w]) { cambio = true; return SINONIMOS[w]; }
      if (voc.mapa[w]) return voc.mapa[w];
      if (w.length < 4 || /\d/.test(w)) return w;
      var max = w.length <= 5 ? 1 : 2, mejor = null, mejorD = max + 1, k, cand, d;
      for (k = 0; k < voc.palabras.length; k++) {
        cand = voc.palabras[k];
        d = distancia(w, cand, max);
        if (d < mejorD || (d === mejorD && mejor && cand.charAt(0) === w.charAt(0) && mejor.charAt(0) !== w.charAt(0))) {
          mejor = cand;
          mejorD = d;
        }
      }
      if (mejor && mejorD <= max) { cambio = true; return voc.mapa[mejor]; }
      return w;
    });
    return cambio ? salida.join(' ') : null;
  }

  function contarSugeridos(q) {
    return fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        return j && j.resources && j.resources.results && j.resources.results.products ? j.resources.results.products.length : 0;
      })
      .catch(function () { return 0; });
  }

  /* Búsqueda por marca y modelo (assets/touche-modelos.js): si ya la resuelve, acá no se corrige ni se redirige */
  function siModelos(terminos, opciones) {
    var p = window.ToucheModelosListo;
    if (!terminos || !p || typeof p.then !== 'function') return Promise.resolve(false);
    return p.then(function (api) { return api.reconoce(terminos, opciones); }).catch(function () { return false; });
  }

  /* Página de resultados */
  function paginaBusqueda() {
    var el = document.getElementById('ToucheBusqueda');
    if (!el) return;
    siModelos(el.getAttribute('data-terms') || '').then(function (es) { if (!es) paginaBusquedaNormal(el); });
  }
  function paginaBusquedaNormal(el) {
    var terminos = el.getAttribute('data-terms') || '';
    var total = parseInt(el.getAttribute('data-count') || '0', 10);
    var params = new URLSearchParams(location.search);
    var original = params.get('corregido');
    var aviso = document.getElementById('ToucheBusquedaAviso');

    if (original) {
      if (!aviso) return;
      var p = new URLSearchParams(location.search);
      p.set('q', original);
      p.delete('corregido');
      p.delete('page');
      p.set('exacta', '1');
      aviso.textContent = '';
      aviso.appendChild(document.createTextNode('Mostramos resultados para '));
      var b = document.createElement('strong');
      b.textContent = '“' + terminos + '”';
      aviso.appendChild(b);
      aviso.appendChild(document.createTextNode('. '));
      var a = document.createElement('a');
      a.href = location.pathname + '?' + p.toString();
      a.textContent = 'Buscar solo “' + original + '”';
      aviso.appendChild(a);
      aviso.hidden = false;
      return;
    }
    if (params.get('exacta') || !terminos || total > 2) return;

    var root = document.documentElement;
    function fin() { root.classList.remove('touche-corrigiendo'); }
    function ir(c) {
      var q = new URLSearchParams(location.search);
      q.set('q', c);
      q.set('corregido', terminos);
      q.delete('page');
      location.replace(location.pathname + '?' + q.toString());
    }
    if (total === 0) {
      root.classList.add('touche-corrigiendo');
      setTimeout(fin, 2500);
    }
    cargarVocabulario().then(function (voc) {
      var c = corregir(terminos, voc);
      if (!c || norm(c) === norm(terminos)) { fin(); return; }
      if (total === 0) { ir(c); return; }
      contarSugeridos(c).then(function (n) { if (n > total) { ir(c); } else { fin(); } });
    });
  }

  /* Buscador rápido */
  function sugerenciaRapida(cont) {
    siModelos(cont.getAttribute('data-touche-terms') || '', { prefijo: true }).then(function (es) { if (!es) sugerenciaRapidaNormal(cont); });
  }
  function sugerenciaRapidaNormal(cont) {
    var terminos = cont.getAttribute('data-touche-terms') || '';
    var total = parseInt(cont.getAttribute('data-touche-count') || '0', 10);
    var caja = cont.querySelector('[data-touche-sugerencia]');
    if (!caja || !terminos || total > 2) return;
    cargarVocabulario().then(function (voc) {
      var c = corregir(terminos, voc);
      if (!c || norm(c) === norm(terminos)) return;
      var go = function () {
        if (total > 0) return Promise.resolve(true);
        return contarSugeridos(c).then(function (n) { return n > 0; });
      };
      go().then(function (vale) {
        if (!vale || !cont.isConnected) return;
        caja.textContent = '';
        caja.appendChild(document.createTextNode('¿Quisiste decir '));
        var a = document.createElement('a');
        a.href = '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(c);
        a.textContent = c;
        a.addEventListener('click', function (e) {
          var scope = cont.closest('predictive-search') || cont.closest('form') || document;
          var input = scope.querySelector('input[name="q"]');
          if (!input) return;
          e.preventDefault();
          input.value = c;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.focus();
        });
        caja.appendChild(a);
        caja.appendChild(document.createTextNode('?'));
        caja.hidden = false;
      });
    });
  }

  function traducirOrden() {
    var ops = document.querySelectorAll('select[name="sort_by"] option, select#SortBy option');
    for (var i = 0; i < ops.length; i++) {
      var t = ORDEN[ops[i].value];
      if (t && ops[i].textContent.trim() !== t) ops[i].textContent = t;
    }
  }

  function revisar() {
    var conts = document.querySelectorAll('[data-touche-terms]:not([data-touche-listo])');
    for (var i = 0; i < conts.length; i++) {
      conts[i].setAttribute('data-touche-listo', '');
      sugerenciaRapida(conts[i]);
    }
    traducirOrden();
  }

  function iniciar() {
    paginaBusqueda();
    revisar();
    var pendiente = false;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      setTimeout(function () { pendiente = false; revisar(); }, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
